export enum ServiceTypeCode {
  ExtraCleaning = 'extraCleaning',
}
